import { CheckIcon } from "@chakra-ui/icons";
import { Checkbox, Heading, HStack } from "@chakra-ui/react";
import { NotificationPreferenceFormItemProps } from "@ui/application/forms";
import { DescriptionPopover } from "./description-popover";

export const PreferenceItem = (props: NotificationPreferenceFormItemProps) => {
  const { id, title, description, isActive, name, onChange } = props;
  return (
    <HStack px="7" py={{ base: "3", md: "6" }} align="center">
      <Checkbox
        id={id}
        isChecked={isActive}
        onChange={onChange}
        name={name}
        colorScheme="green"
        size="md"
        icon={<CheckIcon />}
      />
      <Heading fontSize="sm" textColor="black" fontWeight="medium">
        {title}
        <DescriptionPopover description={description} />
      </Heading>
    </HStack>
  );
};
